(function () {
  'use strict';

  function formatMoney(cents, format) {
    cents = Math.round(cents);
    var fmt = format || '${{amount}}';
    function withDelims(n, precision, thousands, decimal) {
      var num = (n / 100).toFixed(precision);
      var parts = num.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = withDelims(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelims(cents, 2, "'", '.'); break;
      default: value = withDelims(cents, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value).replace(/<[^>]*>/g, '');
  }

  /* ---------- Product: volume pricing ---------- */
  function initProduct(root) {
    var form = root.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var moneyFormat = root.getAttribute('data-money-format');
    var tiers = [];
    try { tiers = JSON.parse(root.getAttribute('data-tiers') || '[]'); } catch (e) {}
    var quoteMin = parseInt(root.getAttribute('data-quote-min') || '0', 10);
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-variants]').textContent); } catch (e) {}

    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = root.querySelector('[data-qty]');
    var variantSelect = root.querySelector('[data-variant-select]');
    var tierButtons = root.querySelectorAll('[data-tier]');
    var addBtn = root.querySelector('[data-add]');
    var buyNowBtn = root.querySelector('[data-buy-now]');
    var returnTo = form.querySelector('input[name="return_to"]');

    function currentVariant() {
      var id = parseInt(idInput.value, 10);
      for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
      return variants[0];
    }
    function tierFor(q) {
      var t = tiers[0] || { min: 1, off: 0 };
      for (var i = 0; i < tiers.length; i++) if (q >= tiers[i].min) t = tiers[i];
      return t;
    }
    function setText(sel, txt) {
      var el = root.querySelector(sel);
      if (el) el.textContent = txt;
    }
    function render() {
      var v = currentVariant();
      if (!v) return;
      var q = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      var t = tierFor(q);
      var unit = v.price * (1 - t.off / 100);
      var total = unit * q;
      var saved = v.price * q - total;

      setText('[data-unit-price]', formatMoney(unit, moneyFormat));
      var was = root.querySelector('[data-was]');
      var savePill = root.querySelector('[data-save-pill]');
      var compare = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : 0;
      if (t.off > 0) {
        was.textContent = formatMoney(v.price, moneyFormat); was.hidden = false;
        savePill.textContent = 'Save ' + t.off + '%'; savePill.hidden = false;
      } else if (compare) {
        was.textContent = formatMoney(compare, moneyFormat); was.hidden = false;
        savePill.textContent = 'Save ' + Math.round((1 - v.price / compare) * 100) + '%'; savePill.hidden = false;
      } else { was.hidden = true; savePill.hidden = true; }

      setText('[data-total]', formatMoney(total, moneyFormat));
      setText('[data-total-label]', 'Total for ' + q + ' ' + (q === 1 ? 'licence' : 'licences'));
      var saveEl = root.querySelector('[data-total-save]');
      if (saveEl) { saveEl.hidden = !(t.off > 0); saveEl.textContent = 'You save ' + formatMoney(saved, moneyFormat); }

      tierButtons.forEach(function (b) {
        var min = parseInt(b.getAttribute('data-tier'), 10);
        b.setAttribute('aria-pressed', String(min === t.min));
        var off = parseFloat(b.getAttribute('data-off'));
        var each = b.querySelector('[data-each]');
        if (each) each.textContent = formatMoney(v.price * (1 - off / 100), moneyFormat) + ' each';
      });

      var notice = root.querySelector('[data-quote-notice]');
      if (notice) notice.hidden = !(quoteMin && q >= quoteMin);

      var available = v.available;
      [addBtn, buyNowBtn].forEach(function (b) { if (b) b.disabled = !available; });
      if (addBtn) addBtn.textContent = available ? addBtn.getAttribute('data-label') : 'Sold out';
    }

    if (variantSelect) variantSelect.addEventListener('change', function () {
      idInput.value = variantSelect.value;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantSelect.value);
      window.history.replaceState({}, '', url.toString());
      render();
    });
    root.querySelectorAll('[data-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = parseInt(b.getAttribute('data-qty-step'), 10);
        qtyInput.value = Math.min(999, Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step));
        render();
      });
    });
    qtyInput.addEventListener('input', render);
    qtyInput.addEventListener('change', function () {
      qtyInput.value = Math.min(999, Math.max(1, parseInt(qtyInput.value, 10) || 1));
      render();
    });
    tierButtons.forEach(function (b) {
      b.addEventListener('click', function () {
        qtyInput.value = b.getAttribute('data-tier');
        render();
      });
    });
    if (buyNowBtn) buyNowBtn.addEventListener('click', function () {
      if (returnTo) returnTo.value = '/checkout';
    });
    if (addBtn) addBtn.addEventListener('click', function () {
      if (returnTo) returnTo.value = '/cart';
    });

    /* thumbnails */
    var main = root.querySelector('[data-main-image]');
    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (main) { main.src = t.getAttribute('data-thumb'); main.alt = t.getAttribute('data-alt') || ''; }
        root.querySelectorAll('[data-thumb]').forEach(function (o) { o.setAttribute('aria-pressed', String(o === t)); });
      });
    });

    render();
  }

  /* ---------- Tabs ---------- */
  function initTabs(root) {
    var tabs = root.querySelectorAll('[role="tab"]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', String(on));
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      });
      tab.addEventListener('keydown', function (e) {
        var list = Array.prototype.slice.call(tabs);
        var i = list.indexOf(tab);
        if (e.key === 'ArrowRight') { list[(i + 1) % list.length].focus(); list[(i + 1) % list.length].click(); }
        if (e.key === 'ArrowLeft') { list[(i - 1 + list.length) % list.length].focus(); list[(i - 1 + list.length) % list.length].click(); }
      });
    });
  }

  /* ---------- Collection filters: auto-submit ---------- */
  function initFilters(form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type="checkbox"], select')) form.submit();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-root]').forEach(initProduct);
    document.querySelectorAll('[data-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-filter-form]').forEach(initFilters);
    document.querySelectorAll('[data-autosubmit]').forEach(function (s) {
      s.addEventListener('change', function () { s.form.submit(); });
    });
  });
})();
